export default __webpack_public_path__ + "static/media/360-cerator-logo.4ce12835.png";